
document.addEventListener("DOMContentLoaded", function () {

document.addEventListener('click', function (e) {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const list = e.target.closest('#predictive-search-results-list');
  if (!list) return;
  const a = e.target.closest('a[href]');
  if (!a || a.getAttribute('href') === '#') return;
  e.stopPropagation();
  window.location.href = a.href;
}, true);


   document.addEventListener('rebuy:smartsearch.quickview.ready', (event) => {
     console.log(event.detail.smartSearchQuickView, "Quickview is ready");
     
     Rebuy.SmartSearch.quickView.quickViewSettings.setting.enabled = false;
     console.log(`Rebuy Search quick view enabled = ${Rebuy.SmartSearch.quickView.quickViewSettings.setting.enabled}`)
  }) 
   

   document.addEventListener('rebuy:smartsearch.resultsPage.ready', (event) => {
     console.log(event.detail.smartSearchResultsPage, "Results Page ready");
     
     Rebuy.SmartSearch.resultsPage.isVisible = false;
     console.log(`Rebuy Search results page enabled = ${Rebuy.SmartSearch.resultPage.isVisible}`)
  })

});